module.exports = __webpack_public_path__ + "static/img/shcygn10.6648685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn10.png
// module id = 371
// module chunks = 0